export default [
  {
    srno: "1",
    title: "Sumit Jaiswal",
    phone: "9821953245",
    groupName: "ABC",
    totalContact: "989284083/9823846582",
  },
  {
    srno: "1",
    title: "Sumit Jaiswal",
    phone: "9821953245",
    groupName: "ABC",
    totalContact: "989284083/9823846582",
  },
  {
    srno: "1",
    title: "Sumit Jaiswal",
    phone: "9821953245",
    groupName: "ABC",
    totalContact: "989284083/9823846582",
  },
  {
    srno: "1",
    title: "Sumit Jaiswal",
    phone: "9821953245",
    groupName: "ABC",
    totalContact: "989284083/9823846582",
  },
];
